export default ({ data }) => {
  const { tweet } = data;
  if (tweet) {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.charSet = 'utf-8';
    s.src = 'https://platform.twitter.com/widgets.js';
    const head = document.getElementsByTagName('head')[0];
    head.appendChild(s);
  }
};
